<script setup>
const content = `Bij de numerieke test werd u gevraagd om het logische verband in een reeks van cijfers te ontdekken. <br> Deze analytische capaciteit is van belang voor functies waarbij berekeningen gemaakt worden en functies waarbij op basis van numeriek materiaal conclusies moeten worden getrokken`
</script>

<template>
  <div class="">
    <InfoTippy :content />
  </div>
</template>
